<ng-template #content_products_action let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.product_config">
        <div class="side_popup_header">
            <span>{{localService.languageContent.table.action}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}">
            <div class="box">
                <div class="row">
                    <div class="col-12" style="text-align: left;">
                        <app-label [Text]="localService.languageContent.product_config.bulk_products" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(1)">
                            <i class="material-icons">file_download</i>
                            {{localService.languageContent.product_config.download_products}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(2)">
                            <i class="material-icons">file_upload</i>
                            {{localService.languageContent.product_config.upload_products}}
                        </button>
                        <span style="display: none;">
                            <app-file-upload [forId]="businessId" [Id]="elementIds.btn_upload_file"
                                [fileUploadFor]="FileUploadFor.Products" [topPosition]="6"
                                (onFileUploaded)="onCloseTrigger()" />
                        </span>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="row">
                    <div class="col-12" style="text-align: left;">
                        <app-label [Text]="localService.languageContent.product_config.bulk_stocks" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(3)">
                            <i class="material-icons">file_download</i>
                            {{localService.languageContent.product_config.less_stock_report}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(4)">
                            <i class="material-icons">file_download</i>
                            {{localService.languageContent.product_config.download_stock}}
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(7)">
                            <i class="material-icons">file_download</i>
                            {{localService.languageContent.product_config.download_stock_price}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(5)">
                            <i class="material-icons">file_upload</i>
                            {{localService.languageContent.product_config.upload_stock}}
                        </button>
                        <span style="display: none;">
                            <app-file-upload [forId]="businessId" [Id]="elementIds.btn_upload_file_stock"
                                [fileUploadFor]="FileUploadFor.UploadStocks" [topPosition]="6"
                                (onFileUploaded)="onCloseTrigger()" />
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="!localService.isHideDummy">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(6)">
                            <i class="material-icons">file_upload</i>
                            {{localService.languageContent.product_config.upload_to_overall_stock}}
                        </button>
                        <span style="display: none;">
                            <app-file-upload [forId]="businessId" [Id]="elementIds.btn_upload_file_overwrite_stock"
                                [fileUploadFor]="FileUploadFor.Products" [topPosition]="6" />
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(8)">
                            <i class="material-icons">file_download</i>
                            {{localService.languageContent.product_config.monthly_stock}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(10)">
                            <i class="material-icons">print</i>
                            {{localService.languageContent.product_config.print_current_stocks}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="onAction(9)">
                            <i class="material-icons">g_translate</i>
                            {{localService.languageContent.product_config.fix_translation}}
                            <span *ngIf="languageVariationCount != ''">&nbsp;-&nbsp;{{languageVariationCount}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-print *ngIf="IsPrint" [fileName]="fileName" [content]="printContent" (onPrinted)="onPrinted()">
    </app-print>
</ng-template>